import {
  useEffect,
  useState
} from 'react';

import GradingPdfViewer
  from './GradingPdfViewer';

import {
  fetchFilesForSubmission
} from '../../../utils/assignmentSubmissionFiles';


export default function MultiFileGradingViewer({
  submission,
  downloadBaseName = ''
}) {
  const [
    files,
    setFiles
  ] =
    useState([]);

  const [
    selectedId,
    setSelectedId
  ] =
    useState('');

  const [
    loading,
    setLoading
  ] =
    useState(true);

  const [
    error,
    setError
  ] =
    useState('');


  const submissionId =
    submission?.id ||
    '';

  const sourceSubmissionId =
    submission
      ?.file_source_submission_id ||
    '';


  useEffect(() => {
    let cancelled =
      false;

    async function load() {
      setLoading(true);
      setError('');

      try {
        const rows =
          await fetchFilesForSubmission({
            id:
              submissionId,

            file_source_submission_id:
              sourceSubmissionId ||
              null
          });

        if (cancelled) {
          return;
        }

        setFiles(
          rows
        );

        setSelectedId(
          rows[0]?.id ||
          ''
        );

      } catch (loadError) {
        console.error(
          'Loading multi-file grading submission failed:',
          loadError
        );

        if (!cancelled) {
          setError(
            loadError?.message ||
            'Could not load the submitted files.'
          );
        }

      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    if (submissionId) {
      load();
    }

    return () => {
      cancelled =
        true;
    };
  }, [
    submissionId,
    sourceSubmissionId,
    submission?.submitted_at
  ]);


  if (loading) {
    return (
      <div
        style={
          styles.state
        }
      >
        Loading submitted files...
      </div>
    );
  }


  if (error) {
    return (
      <div
        style={
          styles.error
        }
      >
        {error}
      </div>
    );
  }


  if (!files.length) {
    return (
      <div
        style={
          styles.error
        }
      >
        This submission is marked as multi-file, but no submitted
        file records were found.
      </div>
    );
  }


  const selected =
    files.find(
      row =>
        row.id ===
        selectedId
    ) ||
    files[0];


  return (
    <div>
      <div
        style={
          styles.tabs
        }
      >
        {files.map(
          file => (
            <button
              key={
                file.id
              }
              type="button"
              style={{
                ...styles.tab,

                ...(
                  file.id ===
                  selected.id
                    ? styles.activeTab
                    : {}
                )
              }}
              onClick={
                () =>
                  setSelectedId(
                    file.id
                  )
              }
            >
              {
                file.slot_label ||
                'Submission file'
              }
            </button>
          )
        )}
      </div>

      <div
        style={
          styles.fileHeading
        }
      >
        <strong>
          {
            selected.slot_label ||
            'Submission file'
          }
        </strong>

        <span
          style={
            styles.fileName
          }
        >
          {
            selected
              .original_file_name ||
            selected.file_name
          }
        </span>
      </div>

      <GradingPdfViewer
        downloadBaseName={
          downloadBaseName
            ? [
                downloadBaseName,
                selected.slot_label || 'File'
              ].join(' - ')
            : ''
        }
        submissionFileId={
          selected.id
        }
        fileName={
          selected.file_name
        }
        reviewPdfDriveFileId={
          selected
            .review_pdf_drive_file_id
        }
      refreshToken={submission?.submitted_at || selected?.drive_file_id}
      />

      {!/\.pdf$/i.test(
        String(
          selected.file_name ||
          ''
        )
      ) && (
        <a
          href={
            'https://drive.google.com/uc?export=download&id=' +
            selected.drive_file_id
          }
          target="_blank"
          rel="noreferrer"
          style={
            styles.downloadLink
          }
        >
          Download original document
        </a>
      )}
    </div>
  );
}


const styles = {
  state: {
    padding:
      '12px',
    color:
      '#66788a'
  },

  error: {
    padding:
      '10px 12px',
    border:
      '1px solid #e6b8b8',
    borderRadius:
      '7px',
    background:
      '#fff5f5',
    color:
      '#8a1f1f',
    fontSize:
      '12px'
  },

  tabs: {
    display:
      'flex',
    gap:
      '6px',
    flexWrap:
      'wrap',
    marginBottom:
      '10px'
  },

  tab: {
    border:
      '1px solid #bcccdc',
    borderRadius:
      '6px',
    background:
      'white',
    color:
      '#486581',
    padding:
      '6px 9px',
    fontSize:
      '12px',
    fontWeight:
      700,
    cursor:
      'pointer'
  },

  activeTab: {
    borderColor:
      '#215b7d',
    background:
      '#e7f1f7',
    color:
      '#215b7d'
  },

  fileHeading: {
    display:
      'flex',
    justifyContent:
      'space-between',
    gap:
      '12px',
    alignItems:
      'center',
    marginBottom:
      '8px',
    fontSize:
      '12px'
  },

  fileName: {
    color:
      '#66788a'
  },

  downloadLink: {
    display:
      'inline-block',
    marginTop:
      '8px',
    color:
      '#215b7d',
    fontSize:
      '13px',
    textDecoration:
      'underline'
  }
};
